<template>
  <div class="footer">
    <!-- 底部冲突提示-->
    <notice-bar
      v-if="showClashTip"
      showClose
      :text="`共有${checkData.schedule.length}个课程发生时间冲突`"
      @close="handleCloseClashTip"
    />
    <!-- 底部操作栏-->
    <div class="footer-inner" :style="{ 'z-index': footerInnerZIndex }">
      <div class="pay-left">
        <!-- 全选按钮存在必须全部勾选，全部不能勾选情况 -->
        <button
          :disabled="isDisabled"
          class="footer-inner-select-btn"
          @click="handleSelectAll"
        >
          <img
            :class="[{ 'must-check': mustCheckBtn && !isDisabled }]"
            :src="
              stateSelectAll
                ? 'https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/select-icon.png'
                : 'https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/unselect-icon.png'
            "
          />
          全选
        </button>
        <div class="footer-inner-total">
          <div class="footer-inner-total-price">
            <span class="text">合计:</span
            ><span class="footer-inner-total-price-symbol">¥</span
            ><span class="footer-inner-total-price-num">{{
              $$(checkPromotionData.end_price) || 0
            }}</span>
          </div>
          <div
            v-if="$$(checkPromotionData.all_discount_amount) > 0"
            class="footer-inner-total-discount"
            @click="handleDiscountExplain"
          >
            优惠共减 ¥{{ $$(checkPromotionData.all_discount_amount) || 0 }}
            <div class="divider"></div>
            明细
            <img
              class="arrow"
              src="https://editor.xesimg.com/tailor/resource/arrow-1761037249759.png"
            />
          </div>
        </div>
      </div>
      <div
        :class="[
          'footer-inner-buy-btn',
          {
            'footer-inner-buy-btn-disabled': disabledBuy || $isLoginFree,
          },
        ]"
        @click="handleBuy"
      >
        立即支付{{ checkNum > 0 ? ` (${checkNum})` : "" }}
      </div>
    </div>
    <van-popup
      v-model="showPopUp"
      :close-on-click-overlay="true"
      :overlay-class="'footer-popup-overlay'"
      class="footer-popup"
      closeable
      position="bottom"
      round
    >
      <div class="footer-popup-detail-title">
        {{ $$(checkPromotionData.title) || "" }}
      </div>
      <div class="footer-popup-detail">
        <!-- 商品总价-->
        <div class="footer-popup-detail-item footer-popup-detail-allPrice">
          <div class="footer-popup-detail-item-title">商品总价</div>
          <div class="footer-popup-detail-item-price">
            ¥{{ $$(checkPromotionData.all_price) || 0 }}
          </div>
        </div>
        <!-- 共优惠-->
        <div class="footer-popup-detail-item footer-popup-detail-discount">
          <div class="footer-popup-detail-item-title">优惠共减</div>
          <div class="footer-popup-detail-item-price">
            -¥{{ $$(checkPromotionData.all_discount_amount) || 0 }}
          </div>
        </div>
        <!-- 满减规则信息-->
        <div class="footer-popup-detail-item footer-popup-detail-info">
          <div
            v-for="(item, index) of $$(checkPromotionData.detail)"
            :key="index"
            class="footer-popup-detail-info-item"
          >
            <div class="footer-popup-detail-item-title-desc">
              {{ $$(item.title) }}
            </div>
            <div class="info-item-price">-¥{{ $$(item.price) }}</div>
          </div>
        </div>
        <!-- 合计-->
        <div class="footer-popup-detail-item footer-popup-detail-total">
          <div class="footer-popup-detail-item-title">合计</div>
          <div class="footer-popup-detail-item-price">
            ¥{{ $$(checkPromotionData.end_price) || 0 }}
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showConflictPopup"
      round
      :close-on-click-overlay="false"
    >
      <div class="select-popup-content">
        <div class="title">产品重复</div>
        <div>{{ popupMsg }}</div>
        <div class="ok-btn" @click.stop="showConflictPopup = false">确认</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { NoticeBar, Popup } from "vant";
import { mapState, mapMutations } from "vuex";
import noticeBar from "../../../components/noticeBar.vue";
import { getCommonLog } from "../../changeCourse/utils/point";
export default {
  components: {
    // "van-notice-bar": NoticeBar,
    noticeBar,
    "van-popup": Popup,
  },
  props: {
    list: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    checkData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabledBuy: {
      type: Boolean,
      default: false,
    },
    showClashTip: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    discount: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 是否必须选中
    mustCheckBtn: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showPopUp: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.footerInnerZIndex = 3000;
        } else {
          setTimeout(() => {
            this.footerInnerZIndex = 10;
          }, 400);
        }
      },
    },
  },
  computed: {
    ...mapState({
      stateUserId: (state) => state.userId,
      stateSelectCourseIds: (state) => state.selectCourseIds,
      stateSelectClassIds: (state) => state.selectClassIds,
      stateSelectAll: (state) => state.selectAll,
      stateContCourseData: (state) => state.contCourseData,
    }),
    checkPromotionData() {
      return this.checkData.promotion || {};
    },
    // 已勾选的商品数量
    checkNum() {
      return this.getAllSelectPackageInfo().length;
    },
  },
  data() {
    return {
      showPopUp: false,
      showConflictPopup: false,
      popupMsg: "",
      footerInnerZIndex: 10,
    };
  },
  methods: {
    ...mapMutations(["SET_SELECT_ALL"]),
    getIds() {
      return this.stateSelectCourseIds
        .map((val, index) => {
          return val + "-" + this.stateSelectClassIds[index];
        })
        .join(",");
    },
    handleSelectAll() {
      if (this.isLoading || this.mustCheckBtn) return; // 请求加价购列表或者计价接口的时候不能全选，不然价格会计算错误
      this.handleDiscountExplain(false);
      this.SET_SELECT_ALL(!this.stateSelectAll);
      this.$emit("selectAll", this.stateSelectAll);
    },
    getRecommendListPackageInfo() {
      let selectArr = [];
      const list = this.list.recom_list;
      for (let item of list) {
        for (let packageItem of item.package_info) {
          if (packageItem.selectType === 2) {
            selectArr.push(packageItem);
          }
        }
      }
      let product_list = [];
      for (let packageItem of selectArr) {
        // 混合品 取混合品id
        if (packageItem.product_type === 300) {
          product_list.push({
            id: packageItem.id,
          });
        } else {
          // 课程  实物
          product_list = product_list.concat(packageItem.product_list);
          product_list = product_list.concat(packageItem.gift_list);
        }
      }
      return product_list.map((item) => item.id);
    },
    getAllSelectPackageInfo() {
      let selectArr = [];
      const tabList = [...this.list.cnt_list, ...this.list.recom_list];
      for (let item of tabList) {
        for (let packageItem of item.package_info) {
          if (packageItem.selectType === 2) {
            selectArr.push(packageItem);
          }
        }
      }

      return selectArr;
    },
    // 判断商品重复
    haveRepeatProduct() {
      const selectInfoList = this.getAllSelectPackageInfo();
      console.log("selectInfoList--", selectInfoList);
      let productIdObj = {}; // 当前商品对象 key id value 为1时表示存在
      let repeatProduct = []; // 重复的商品和赠品进行去重展示
      for (let packageItem of selectInfoList) {
        const allCourseList = [
          ...(packageItem?.product_list || []),
          ...(packageItem?.gift_list || []),
        ];
        //找出packageItem?.product_list中id相同的数据
        allCourseList?.map((productItem) => {
          if (productIdObj[productItem.id]) {
            productIdObj[productItem.id].push(packageItem.name);
            repeatProduct = repeatProduct.concat(productIdObj[productItem.id]);
          } else {
            productIdObj[productItem.id] = [packageItem.name];
          }
        });
      }
      console.log("productIdObj---", productIdObj);
      console.log("repeatProduct---", repeatProduct);
      // 遍历repeatProduct，拼接提示语
      if (repeatProduct.length > 0) {
        let packageNames = Array.from(new Set(repeatProduct));
        this.popupMsg = `${packageNames.join("、")}，商品重复`;
        this.showConflictPopup = true;
        return true;
      } else {
        this.popupMsg = "";
        return false;
      }
    },
    // 校验
    canBuy() {
      // 首先校验所有选中项是否存在诊断和待开售商品
      const selectInfoList = this.getAllSelectPackageInfo();
      // 若selectInfoList中的status包含5（需要诊断） || 11（待开售）那么不能下单
      const error = selectInfoList.filter((item) => item.status.id === 5);
      if (error?.length > 0) {
        this.$toast("存在需要诊断的商品，请诊断后下单");
        return false;
      }
      // 接下来判断是否存在课程冲突
      return !this.haveRepeatProduct();
    },
    // 组装旧的支付逻辑参数
    assemblyOldBuyParams(selectInfoList, recomId) {
      console.log("recomId---", recomId);
      const data = {
        productIds: [],
        source: 18,
        sourceIdMap: {},
      };
      let product_list = [];
      for (let packageItem of selectInfoList) {
        product_list = product_list.concat(packageItem.product_list);
      }
      for (let course of product_list) {
        data.productIds.push(`${course.id}-${course.extra_info.class_id}`);
        if (recomId.includes(course.id)) {
          data.sourceIdMap[course.id] = "636174960";
        }
      }
      if (Object.keys(data.sourceIdMap)?.length > 0) {
        data.sourceId = "636174960";
        data.sourceIdMap = JSON.stringify(data.sourceIdMap);
      } else {
        delete data.sourceIdMap;
      }
      console.log("旧的支付参数----sourceIdMap---", data.sourceIdMap);
      data.productIds = data.productIds.join(",").toString();
      console.log("旧的支付参数---", data);
      return data;
    },
    /** 立即购买 */
    handleBuy() {
      if (this.disabledBuy || !this.canBuy() || this.$isLoginFree) return;
      const selectInfoList = this.getAllSelectPackageInfo();
      const recomId = this.getRecommendListPackageInfo();
      // 遍历所有选中数据的product_list,填充config.products
      let product_list = [];
      for (let packageItem of selectInfoList) {
        // 混合品
        if (packageItem.product_type === 300) {
          product_list.push({
            id: packageItem.id,
            type: packageItem.product_type,
            isAddPriceBuy: packageItem.isAddPriceBuy,
          });
        } else {
          packageItem.product_list?.forEach(
            (item) => (item.isAddPriceBuy = packageItem?.isAddPriceBuy)
          );
          packageItem.gift_list?.forEach(
            (item) => (item.isAddPriceBuy = packageItem?.isAddPriceBuy)
          );
          // 课程  实物
          product_list = product_list.concat(packageItem.product_list);
          product_list = product_list.concat(packageItem.gift_list);
        }
      }
      // 扩科品的下单埋点数据传给确认下单页面
      const increasePoint = selectInfoList
        .filter((item) => item.isAddPriceBuy)
        .map((item) => {
          return {
            commodity_order_source: 1, // 1资源位 2 弹窗
            pointFrom: 2, // 代表来源是续报中心
            ...getCommonLog(item),
          };
        });
      const increase_list = (this.stateContCourseData?.recom_list || []).filter(
        (item) => item.isAddPriceBuy
      );
      const config = {
        "X-Businessline-Id": 10,
        source: 18, // 产品确认
        order_device: 3, // h5都是touch端
        order_type: 22, // 后台确认
        products: [],
        extras: {
          class: "",
          respos_type2_launch: increase_list.length ? "1" : "2", // 是否有扩科资源位推出
        },
      };
      if (increasePoint.length) {
        config.extras.increasePoint = JSON.stringify(increasePoint);
      }
      if (selectInfoList?.filter((item) => item.isAddPriceBuy).length > 0) {
        config.promotion_source = config.source;
      }
      config.products = product_list.map((item) => {
        const data = {
          id: item.id,
          quantity: 1,
          type: item.type,
        };
        if (recomId.includes(item.id)) {
          data.source_id = "636174960";
        }
        return data;
      });
      // 如果有推荐课程，那么source_id为636174960
      //   if (recomId?.length > 0) {
      //     config.source_id = "636174960";
      //   }
      const extrasClass = {};
      let extrasProduct = [];
      for (let packageItem of selectInfoList) {
        // 课程  实物
        extrasProduct = extrasProduct.concat(packageItem.product_list);
        extrasProduct = extrasProduct.concat(packageItem.gift_list);
      }
      for (const p of extrasProduct) {
        if (p.type === 100) {
          // 100为课程 105w为实物
          extrasClass[p.id] = p.extra_info?.class_id;
        }
      }
      config.extras.class = JSON.stringify(extrasClass);
      config.discount = this.discount;
      console.log("新的支付参数---", config);
      this.$xesLogger.clickMsg({
        params: {
          click_id: "click_ZHnxQP1v",
          click_name: "立即购买点击",
          current_id: sessionStorage.getItem("page_load_current_id"), // 用于统计页面曝光到下单的时间差
          list: selectInfoList?.map((item) => {
            return {
              respos_type: item.cardType === "raw" ? 1 : 2,
              ...getCommonLog(item),
            };
          }),
        },
      });
      // config.sourceId = 12345678;
      // 判断若所有选中的数据都是课程，那么走老的下单逻辑 和后端老师确认都走新的逻辑
      // if (selectInfoList?.every((item) => item.product_type === 100)) {
      //   this.$emit(
      //     "buyOld",
      //     this.assemblyOldBuyParams(selectInfoList, recomId)
      //   );
      //   return;
      // }
      this.$emit("buy", config);
    },
    /* 优惠弹窗弹出情况下，点击全选或立即购买按钮，关闭弹窗*/
    handleDiscountExplain(flag) {
      this.showPopUp = !flag ? flag : !this.showPopUp;
      if (flag) {
        window.__XES_LOG__?.clickMsg({
          params: {
            data_clickid: "1.2.6",
            user_id: this.stateUserId,
            click_name: "优惠明细点击",
          },
        });
      }
    },
    handleCloseClashTip() {
      this.$emit("close-clash-tip");
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";

.footer {
  width: 100vw;
  position: fixed;
  bottom: -1px;
  z-index: 10;
}

.footer-inner {
  position: relative;
  z-index: 10;
  height: 56px;
  padding: 0 12px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #ffffff;
  display: flex;
  align-items: center;

  .pay-left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    margin-right: 16px;
  }

  .footer-inner-select-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: none;
    border: none;
    color: #666;
    text-align: right;
    font-family: PingFang SC;
    font-size: 13px;
    font-weight: 400;

    img {
      width: 28px;
      height: 28px;
    }
  }

  .footer-inner-total {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    font-size: 15px;
    color: #333333;

    .footer-inner-total-price {
      color: #333;
      font-family: PingFang SC;
      font-size: 13px;
      font-style: normal;
      line-height: normal;

      .text {
        font-weight: 600;
        margin-right: 4px;
      }

      .footer-inner-total-price-symbol {
        color: #f93834;
        font-family: DIN-Bold-700;
        font-size: 13px;
        line-height: 13px; /* 100% */
      }

      .footer-inner-total-price-num {
        font-size: 21px;
        margin-left: 2px;
        font-family: DIN-Bold-700;
        color: #f93834;
      }
    }

    .footer-inner-total-discount {
      display: flex;
      align-items: center;
      color: #999;
      font-family: PingFang SC;
      font-size: 13px;
      font-weight: 400;
      margin-top: 1px;

      .divider {
        width: 1px;
        height: 11px;
        margin: 0 6px;
        border-radius: 6px;
        background: #999;
      }

      .arrow {
        width: 8px;
        height: 8px;
        margin-left: 4px;
      }
    }
  }

  .footer-inner-buy-btn {
    .flex-center-center;
    height: 40px;
    line-height: 40px;
    width: 126px;
    background: #f93834;
    border-radius: 20px;
    color: #fff;
    font-family: PingFang SC;
    font-size: 15px;
    font-weight: 500;

    &.footer-inner-buy-btn-disabled {
      color: #adadad;
      background-color: rgba(153, 153, 153, 0.1);
    }
  }
}

.footer-popup {
  margin-bottom: calc(55px + constant(safe-area-inset-bottom));
  margin-bottom: calc(55px + env(safe-area-inset-bottom));

  /deep/ .van-popup__close-icon {
    color: #333333;
    font-size: 18px;
  }

  .footer-popup-detail-title {
    .flex-center-center;
    height: 52px;
    font-family: PingFang SC;
    font-size: 17px;
    font-weight: 500;
    color: #333333;
    width: 375px;
  }

  .footer-popup-detail {
    display: flex;
    flex-direction: column;
    padding: 16px 12px;
    font-size: 15px;
    color: #333333;

    .footer-popup-detail-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 21px;
      margin-bottom: 16px;

      .footer-popup-detail-item-price {
        color: #333;
        font-family: DINAlternate-Bold;
        font-size: 17px;
      }

      &.footer-popup-detail-info {
        display: flex;
        flex-direction: column;
        height: auto;

        .footer-popup-detail-info-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          line-height: 18px;
          width: 100%;
          font-size: 13px;
          color: #666666;
          margin-bottom: 16px;

          &:last-child {
            margin-bottom: 0;
          }

          .info-item-price {
            color: #f93834;
            font-family: "PingFang SC";
            font-size: 13px;
            font-weight: 600;
          }

          .footer-popup-detail-item-title-desc {
            color: #333;
            font-family: "PingFang SC";
            font-size: 13px;
            font-weight: 400;
            width: 234px;
            text-overflow: ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
            white-space: nowrap; /*让文字不换行*/
            overflow: hidden; /*超出要隐藏*/
            line-height: 21px;
          }
        }
      }

      &.footer-popup-detail-discount {
        .footer-popup-detail-item-price {
          color: #f93834;
        }
      }
    }
  }
}

.footer-popup-detail-item-title {
  color: #333;
  font-family: PingFang SC;
  font-size: 15px;
  font-weight: 600;
}

/deep/ .footer-popup-overlay {
  height: calc(100% - 56px - constant(safe-area-inset-bottom));
  height: calc(100% - 56px - env(safe-area-inset-bottom));
}

.select-popup-content {
  .column-center-start;
  width: 308px;
  padding: 24px;
  word-break: break-all;
  box-sizing: border-box;
  color: #333;
  text-align: center;
  font-family: "PingFang SC";
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  .title {
    margin-bottom: 12px;
    color: #333;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 17px;
    font-weight: 500;
  }

  .ok-btn {
    .flex-center-center;
    width: 244px;
    height: 40px;
    border-radius: 20px;
    color: #fff;
    font-family: PingFang SC;
    font-size: 15px;
    font-weight: 500;
    margin-top: 28px;
    background-color: rgba(249, 56, 52, 1);
  }
}

.must-check {
  opacity: 0.5;
}
</style>
